// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__mElEu","active":"Tabs_active__RXc5W"};